import React, { CSSProperties, ComponentProps } from "react";
import { Image } from "react-bootstrap";

import "./TooltipButton.scss";
import ImageAlertWarningCircle from "../../../images/interface-alert-warning-circle-interface-light-purple.svg";
import GhostButton from "../GhostButton/GhostButton";

interface TooltipButtonProps extends ComponentProps<"button"> {
  iconStyles?: CSSProperties;
}

function TooltipButton({
  iconStyles,
  className = "",
  ...restProps
}: TooltipButtonProps) {
  return (
    <GhostButton
      className={`tooltip-btn ${className}`}
      aria-label="view more info"
      {...restProps}
    >
      <Image
        src={ImageAlertWarningCircle}
        className="alertImage"
        style={iconStyles}
      />
    </GhostButton>
  );
}

export default TooltipButton;
